<template>
    <span :id="'nineblock-' + name"></span>
</template>

<script>
import axios from 'axios'

export default {
    name: 'nine-block',
    props: ['name', 'options', 'pane'],
    data: function() {
        return {
            kxd_NBM: null,
            render_NBM: null,
            builder: null,
            default_color: this.options.default_color || '#fff', //spot預設顏色
            column_map: this.options.column_map, //(*)propoties欄位對照
            // wm config
            max: this.options.config.max || 100, //marker數量上限
            zero_style: this.options.config.zero_style || 2, //無風狀態的樣式
            mps_to_knots: this.options.config.mps_to_knots || 2, //1mps*N = 1kt
            collision_enable: this.options.config.collision_enable === false ? false : true, //碰撞處理
            color_map: this.options.config.color_map, //(*)色階對照
            popup_map: this.options.config.popup_map || null,
            json_map: [],
        }
    },
    computed: {
        color_str: function() {
            return this.color_map.flat().join(',')
        },
        color_vals: function() {
            return this.color_map
                .map((o) => {
                    return o[3]
                })
                .reverse()
        },
        color_code: function() {
            return this.color_map
                .map((o) => {
                    return 'rgb(' + o[0] + ',' + o[1] + ',' + o[2] + ')'
                })
                .reverse()
        },
    },
    watch: {
        'options.url'() {
            this.init_kxd_NBM()
        },
    },
    mounted: function() {
        this.init_kxd_NBM()
    },
    methods: {
        async init_kxd_NBM() {
            this.kxd_NBM = new X.NBMData()
            this.render_NBM = new X.Renderer(this.pane, { pane: this.name })
            this.builder = new X.NineBlockMarkers(this.pane._map, this.render_NBM)

            const builder = this.builder
            builder.setWindZeroStyle(this.zero_style) //無風狀態的樣式: 2(預設)|1
            builder.setMarkerMax(this.max) //設定marker數量上限 (default:100)
            builder.collisionEnable(this.collision_enable) //啟動碰撞處理
            builder.setIDPrefix(`NB-${this.name}-`) //設定elementIDprefix
            builder.setMpsToKnots(this.mps_to_knots) //1mps*N = 1kt (default:2)
            builder.setDefaultColor(this.default_color)
            builder.setColorScale(this.color_str)

            this.change(this.options.url, () => {
                this._extend_pane()

                if (this.options.callback) {
                    this.options.callback(this.pane._leaflet_id)
                }
            })
        },

        change: function(url, callback) {
            const builder = this.builder
            // 使已讀取過的檔案不重複讀取
            const is_loaded = this.json_map.map(({ id_url }) => id_url).some((id_url) => id_url === url)
            if (is_loaded) {
                const current_json = this.json_map.find(({ id_url }) => id_url === url)
                this._render_map(current_json.json_file, builder, callback)
                return
            }

            axios.get(url).then((json) => {
                this.json_map.push({
                    id_url: url,
                    json_file: json,
                })
                this._render_map(json, builder, callback)
            })
        },
        _render_map: function(json, builder, callback) {
            let exist_ID_list = []
            const pointToLayerCallback = this.options.pointToLayerCallback
            if (builder.getMarkerCount() > 0) {
                exist_ID_list = builder.getIDList().slice(0)
            }

            json.data.features.forEach((vals, i) => {
                if (pointToLayerCallback) pointToLayerCallback(vals)

                const nb_ID = this._add(vals, i)
                if (exist_ID_list.includes(nb_ID)) {
                    const idx = exist_ID_list.indexOf(nb_ID)
                    exist_ID_list.splice(idx, 1)
                }
            })

            //移除已不存在的marker
            exist_ID_list.forEach(function(id) {
                builder.remove(id)
            })

            this.set_boundary()

            if (callback) {
                callback()
            }
        },
        set_boundary: function() {
            $(this.pane.$el)
                .find('canvas')
                .css('pointer-events', 'none')

            const builder = this.builder
            builder.boundDisplay() //邊界內偵測 顯示
            if (this.collision_enable) {
                builder.collisionDetect() //碰撞偵測 顯示
            }
        },
        set_point_front_style: function(options) {
            // 非法值Point, 如沒有風速沒風向
            // radius/fill/fillColor/fillOpacity/stroke
            this.builder.setPointFrontStyle(options)
        },
        set_point_back_style: function(options) {
            // 碰撞Point
            // radius/fill/fillColor/fillOpacity/stroke
            this.builder.setPointBackStyle(options)
        },
        _add: function(vals, idx) {
            const v_map = this.column_map.val_map || []
            const spd = this.column_map.spd
            const dir = this.column_map.dir
            const compare = this.column_map.compare || spd //預設:風速
            const color = this.column_map.color //預設:同碰撞
            const properties = vals.properties || {}
            const marker_color = vals['marker-color']

            const ID = this.column_map.ID ? properties[this.column_map.ID] : this.name + idx
            const lat = properties[this.column_map.lat]
            const lng = properties[this.column_map.lng]

            // 九宮格顯示數值陣列
            let nb_vals = v_map.map((column) => {
                return properties[column] || null
            })

            // 調整數值, 非法值要設定成 null
            if (this.options.val_format) {
                nb_vals = this.options.val_format(nb_vals)
            }

            // 九宮格數值分布
            // [5][6][7]
            // [3][X][4]
            // [0][1][2]
            const nb_data = this.kxd_NBM.marker(
                ID, //ID
                lat,
                lng,
                this.kxd_NBM.blocks(
                    nb_vals[0], //0
                    nb_vals[1], //1
                    nb_vals[2], //2
                    nb_vals[3], //3
                    nb_vals[4], //4
                    nb_vals[5], //5
                    nb_vals[6], //6
                    nb_vals[7] //7
                ),
                // 風標顏色優先順序 colorValue > windBarb options color > setDefaultColor
                {
                    name: properties[this.column_map.name],
                    ...(properties[compare] && { compareValue: properties[compare] }), //碰撞時的依據欄位
                    ...(properties[color] && { colorValue: properties[color] }),
                    ...(properties[spd] && { quantity: properties[spd] }),
                    ...(properties[dir] && { direction: properties[dir] }),
                    // windBarb: {
                    //     options: { color: '#fff' },
                    // },
                    display: {
                        name: true,
                    },
                    point: {
                        frontStyle: {
                            fillColor: marker_color,
                            radius: 3,
                        },
                        backStyle: {
                            fillColor: marker_color,
                            fillOpacity: 1,
                            radius: 2,
                        },
                    }, // 有風標則不畫 Point,
                }
            )

            //create marker
            const builder = this.builder
            const nb_marker = builder.add(nb_data, this.pane, { pane: this.name })

            // popup 資料

            if (this.popup_map) {
                // 新增一個 click evnet 事件
                const emit_popup_callback = this.options.emit_popup_callback
                if (emit_popup_callback) {
                    const options = {
                        id: `${this.name}-${ID}`,
                        feature: vals,
                        popup: this.popup_map,
                    }
                    nb_marker.on('click', () => emit_popup_callback(options))
                } else {
                    const popup_html = this._get_popup_html(properties)
                    nb_marker.bindPopup(popup_html)
                    nb_marker.options.point.icon.on('click', (e) => {
                        // 顯示資訊
                        if (popup_html) {
                            e.target.bindPopup(popup_html).openPopup()
                        }
                    })
                }
            }

            return nb_data.ID
        },
        _get_popup_html: function(data) {
            let popup_data = this._get_popup_data(data)

            // 調整popup資料
            if (this.options.popup_format) {
                popup_data = this.options.popup_format(popup_data)
            }

            let html = '<table class="popup-table striped">'
            $.each(popup_data, function(key, value) {
                html += '<tr><td>' + key + '</td><td>' + value + '</td></tr>'
            })
            html += '</table>'

            return html
        },
        _get_popup_data: function(data) {
            let popup_data = {}

            $.each(this.popup_map, function(i, o) {
                const value = o.column
                    .map((column) => {
                        return data[column] || '---'
                    })
                    .join(' ')
                const unit = o.unit ? ' ' + o.unit : ''

                popup_data[o.name] = value + unit
            })

            return popup_data
        },
        _extend_pane: function() {
            // 擴充方法到pane, for pane 操作
            if (!this.pane.nb_render) {
                this.pane.nb_render = {}
            }

            this.pane.nb_render.change = this.change
            this.pane.nb_render.set_boundary = this.set_boundary
            this.pane.nb_render.set_point_front_style = this.set_point_front_style
            this.pane.nb_render.set_point_back_style = this.set_point_back_style
        },
    },
}
</script>

<style lang="css"></style>
